import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Checkbox, Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import EllipsisHover from '@home/components/EllipsisHover';
import { getLocaleText } from '@intelligence/components/GenreSelect/utils';

import type { CheckboxProps } from 'tea-component';
import type { IBaseProps } from '@intelligence/components/GenreSelect/types';

import '@intelligence/components/GenreSelect/components/Checkboxbar/index.scss';

type IBaseCheckboxbarProps = Pick<CheckboxProps, 'disabled' | 'value' | 'indeterminate' | 'onChange'>;

interface ICheckboxbarProps extends IBaseProps, IBaseCheckboxbarProps {
  // 是否展示右侧的右箭头
  showRightArrow?: boolean;
  // 是否高亮
  active?: boolean;
  // 禁用提示文案
  disabledTips?: string;
  // 禁用提示文案（中文）
  disabledTipsCN?: string;
  // 展示的label文案
  label?: string;
  onClick?: () => void;
}

const getBubbleContent = (
  locale: string,
  payload: {
    disabled: boolean;
    disabledTips?: string;
    disabledTipsCN?: string;
  },
): string => {
  const { disabled, disabledTips, disabledTipsCN } = payload || {};
  if (!disabled) return '';
  if (!disabledTips || !disabledTipsCN) return '';
  return getLocaleText(locale, { text: disabledTips, textCN: disabledTipsCN });
};

const Checkboxbar: React.FC<ICheckboxbarProps> = (props) => {
  const {
    style,
    className,
    showRightArrow = false,
    active = false,
    disabled = false,
    disabledTips,
    disabledTipsCN,
    label,
    value,
    indeterminate,
    onChange,
    onClick,
  } = props;

  const { locale } = useIntl();

  const bubbleContent = getBubbleContent(locale, {
    disabled,
    disabledTips,
    disabledTipsCN,
  });

  return (
    <div
      style={style}
      className={classnames('intelligence-genre-checkbox-bar', className, { active })}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onClick?.();
      }}
    >
      <Bubble dark arrowPointAtCenter placement="top" content={bubbleContent}>
        <Checkbox
          className="genre-checkbox-checkbox"
          disabled={disabled}
          defaultValue={value}
          indeterminate={indeterminate}
          value={value}
          onChange={(value, context) => {
            // 半选状态下 触发勾选行为，否则直接用Checkbox的onChange返回的值即可
            onChange?.(indeterminate ? true : value, context);
          }}
        />
      </Bubble>
       <span className={classnames('genre-checkbox-label', { 'is-sub': !showRightArrow })}>
         <EllipsisHover text={label} />
       </span>
      {showRightArrow && <SvgIcon type="point-right" className="genre-checkbox-right-icon" />}
    </div>
  );
};

export default Checkboxbar;
